import React, { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import { baseUrl, theme } from "../../../../config/Config";
import { getApiCall, postApiCall } from "../../../../ApiHelper";
import FundsDataGrid from "../Funds/FundsDataGrid";
import FundsEmailDialogBox from "./FundsEmailDialogBox";
import Fundsdatagrid from "./Fundsdatagrid";
import { Button, Grid } from "@mui/material";
import { approverresponse } from "../../../interfaces/Interfaces";
import { fundEmailResponse } from "../../../interfaces/Interfaces";
import { verbiageProjectResponse } from "../../../interfaces/Interfaces";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { drop } from "lodash";
import { toast } from "../../../interfaces/Interfaces";
import { ToastMessage } from "../../../components/utils/ToastMessage";

const FundsEmail = () => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [rowData, setRowData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [approverlevel, setapproverlevel] = useState<any>();
  const [approvers, setapprovers] = useState<any>();
  const [type, setType] = useState<string>("");
  const [fund, setFundData] = useState<any>();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<toast>({
    message: "",
    severity: "",
  });
  const [submitClicked, setSubmitClicked] = useState<boolean>(false);
  const [gridDropDown, setGridDropDown] = useState<any>({
    approverLevel: [],
    approverName: [],
    approverEmail: [],
    fund: [],
    CreatedBy: [],
    CreatedOn: [],
    UpdatedBy: [],
    UpdatedAt: [],
  });
  const [approverdropdown, setApproverdropdown] = useState<any>({
    approverLevel: [],
    approverName: [],
    fund: [],
  });

  const [approvernamedropdown, setapprovernamedropdown] = useState<any>();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [updateData, setUpdateData] = useState<fundEmailResponse>({
    id: null,
    fundName: [],
    authorizationType: {
      name: "",
      value: "",
    },
    emails: "",
    isActive: true,
  });

  useEffect(() => {
    if (submitClicked) {
      getApproverData();
    }
  }, [submitClicked]);

  useEffect(() => {
    getApproverData();
  }, []);

  useEffect(() => {
    if (!openDialog) {
      setUpdateData({
        id: null,
        fundName: [],
        authorizationType: {
          name: "",
          value: "",
        },
        emails: "",
        isActive: true,
      });
    }
  }, [openDialog]);

  const errorToastMsgwithCode = (err: any) => {
    setToast(true);
    setToastMessage({
      message: `${err.response.data.description} (${err.response.data.code})`,
      severity: "error",
    });
    setTimeout(() => setToast(false), 4000);
  };
  const getApproverData = async () => {
    var url = `${baseUrl}FundEmail/info`;

    try {
      setLoading(true);
      const res = await getApiCall(url).then((response: any) => {
        const formattedRows = response?.fundEmailData?.map((row: any) => ({
          ...row,
          isActive: row?.isActive ? "Yes" : "No",
        }));
        setRowData(formattedRows);
        setGridDropDown({
          authName: response?.authName,

          fundName: response?.fundName,
          CreatedBy: response?.createdBy,
          CreatedOn: response?.createdOn,
          UpdatedBy: response?.updatedBy,
          UpdatedAt: response?.updatedAt,
        });
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      errorToastMsgwithCode(error);
      console.log("error in fetching funds", error);
    }
  };
  const addApproverdropdown = async () => {
    setSubmitClicked(false);
    setOpenDialog(true);
    setLoading(false);
    // /api/FundEmail/dropdowns
    if (
      approverdropdown.approverLevel?.length === 0 ||
      approverdropdown.approverName?.length === 0
    ) {
      var url = `${baseUrl}FundEmail/dropdowns`;
      {
        try {
          const res = await getApiCall(url).then((response: any) => {
            setApproverdropdown(response);
            console.log(approverdropdown, "approvers");
          });
        } catch (error) {
          errorToastMsgwithCode(error);
          console.log("error in fetching funds", error);
        }
      }
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="wrapper">
        <Grid item lg={4}>
          <h2 className="text-left mstitle">Funds Email</h2>
        </Grid>
        {openDialog ? (
          <FundsEmailDialogBox
            open={openDialog}
            rowdata={rowData}
            setOpen={setOpenDialog}
            updateRow={updateData}
            // approverlevel={approverlevel}
            approverdropdown={approverdropdown}
            // approversdata={approvers}
            // fundNames={fund}
            submitClicked={setSubmitClicked}
            type={type}
          />
        ) : null}
        <Fundsdatagrid
          rowdata={rowData}
          loading={loading}
          gridDropDown={gridDropDown}
          addApproverdropdown={addApproverdropdown}
          open={setOpenDialog}
          setOpen={setOpenDialog}
          type={setType}
          submitClicked={submitClicked}
          updateRow={setUpdateData}
        />
        {toast && (
          <ToastMessage
            message={toastMessage.message}
            severity={toastMessage.severity}
          />
        )}
      </div>
    </ThemeProvider>
  );
};
export default FundsEmail;
